import React from 'react';

export type IconProps = {
  stroke?: string;
  className?: string;
};

export const ArrowRight = ({ stroke = 'white' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.75 12H20.25"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 5.25L20.25 12L13.5 18.75"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowLeft: React.FC<IconProps> = ({ stroke = 'white' }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.875 10H3.125"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75 4.375L3.125 10L8.75 15.625"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowUp = () => {
  return (
    <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8004 0.7094C12.589 0.495429 12.3008 0.375 12 0.375C11.6992 0.375 11.411 0.495429 11.1996 0.7094L1.07464 10.9594C0.638003 11.4014 0.642373 12.1137 1.0844 12.5504C1.52643 12.987 2.23872 12.9826 2.67536 12.5406L10.875 4.23973V26.375C10.875 26.9963 11.3787 27.5 12 27.5C12.6213 27.5 13.125 26.9963 13.125 26.375V4.23973L21.3246 12.5406C21.7613 12.9826 22.4736 12.987 22.9156 12.5504C23.3576 12.1137 23.362 11.4014 22.9254 10.9594L12.8004 0.7094Z"
        fill="url(#paint0_linear_2209_4953)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2209_4953"
          x1="12"
          y1="0.375"
          x2="12"
          y2="27.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3C23" />
          <stop offset="1" stopColor="#FF8B23" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ArrowUpSmall = () => {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35158 0.397729C6.44001 0.361059 6.53698 0.34082 6.63867 0.34082C6.74036 0.34082 6.83733 0.361059 6.92576 0.397729C7.01422 0.434329 7.09709 0.488583 7.169 0.56049L12.9815 6.37299C13.2744 6.66588 13.2744 7.14076 12.9815 7.43365C12.6886 7.72654 12.2137 7.72654 11.9208 7.43365L7.38867 2.90148V15.2992C7.38867 15.7134 7.05289 16.0492 6.63867 16.0492C6.22446 16.0492 5.88867 15.7134 5.88867 15.2992V2.90148L1.3565 7.43365C1.06361 7.72654 0.588735 7.72654 0.295841 7.43365C0.00294781 7.14076 0.00294781 6.66588 0.295841 6.37299L6.10834 0.56049C6.18025 0.488583 6.26312 0.434329 6.35158 0.397729Z"
        fill="url(#paint0_linear_2209_5133)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2209_5133"
          x1="6.63867"
          y1="0.34082"
          x2="6.63867"
          y2="16.0492"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3C23" />
          <stop offset="1" stopColor="#FF8B23" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const UpRightArrow = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 0.5H2.5C2.22386 0.5 2 0.723858 2 1C2 1.27614 2.22386 1.5 2.5 1.5H7.79289L0.646447 8.64645C0.451184 8.84171 0.451184 9.15829 0.646447 9.35355C0.841709 9.54882 1.15829 9.54882 1.35355 9.35355L8.5 2.20711V7.5C8.5 7.77614 8.72386 8 9 8C9.27614 8 9.5 7.77614 9.5 7.5V1C9.5 0.862468 9.44447 0.737906 9.35461 0.647509L9.35355 0.646447L9.35249 0.645388C9.3048 0.597975 9.24993 0.562159 9.19139 0.537939C9.13244 0.513493 9.06779 0.5 9 0.5Z"
        fill="white"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const Union = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2803 1.78033C15.5732 1.48744 15.5732 1.01256 15.2803 0.71967C14.9874 0.426777 14.5126 0.426777 14.2197 0.71967L8 6.93934L1.78033 0.71967C1.48744 0.426777 1.01256 0.426777 0.71967 0.71967C0.426777 1.01256 0.426777 1.48744 0.71967 1.78033L6.93934 8L0.71967 14.2197C0.426777 14.5126 0.426777 14.9874 0.71967 15.2803C1.01256 15.5732 1.48744 15.5732 1.78033 15.2803L8 9.06066L14.2197 15.2803C14.5126 15.5732 14.9874 15.5732 15.2803 15.2803C15.5732 14.9874 15.5732 14.5126 15.2803 14.2197L9.06066 8L15.2803 1.78033Z"
        fill="white"
      />
    </svg>
  );
};

export const HambugerIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5616_239)">
        <path
          d="M3.75 12H20.25"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 6H20.25"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 18H20.25"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5616_239">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckMark: React.FC<IconProps> = ({ stroke }) => {
  return (
    <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 1L8 15L1 8"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Mail: React.FC<IconProps> = ({ stroke }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 7H28V24C28 24.2652 27.8946 24.5196 27.7071 24.7071C27.5196 24.8946 27.2652 25 27 25H5C4.73478 25 4.48043 24.8946 4.29289 24.7071C4.10536 24.5196 4 24.2652 4 24V7Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 7L16 18L4 7"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Star = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.3437 14.8985L14.2812 17.3985C14.7891 17.7188 15.4141 17.2422 15.2656 16.6563L14.125 12.1719C14.0942 12.0476 14.0991 11.9171 14.1391 11.7955C14.1792 11.6738 14.2529 11.566 14.3516 11.4844L17.8828 8.53908C18.3437 8.15627 18.1094 7.38283 17.5078 7.34377L12.8984 7.04689C12.7727 7.03958 12.6518 6.99578 12.5505 6.92086C12.4492 6.84594 12.3719 6.74314 12.3281 6.62502L10.6094 2.29689C10.5639 2.17182 10.481 2.06377 10.372 1.98742C10.263 1.91107 10.1331 1.87012 10 1.87012C9.8669 1.87012 9.73703 1.91107 9.62802 1.98742C9.519 2.06377 9.43612 2.17182 9.39062 2.29689L7.67187 6.62502C7.62807 6.74314 7.5508 6.84594 7.44952 6.92086C7.34824 6.99578 7.22733 7.03958 7.10156 7.04689L2.49218 7.34377C1.89062 7.38283 1.65625 8.15627 2.11718 8.53908L5.64843 11.4844C5.74713 11.566 5.82077 11.6738 5.86085 11.7955C5.90094 11.9171 5.90584 12.0476 5.875 12.1719L4.82031 16.3281C4.64062 17.0313 5.39062 17.6016 5.99218 17.2188L9.65625 14.8985C9.759 14.8331 9.87824 14.7984 10 14.7984C10.1218 14.7984 10.241 14.8331 10.3437 14.8985V14.8985Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Check = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.875 5.625L8.125 14.375L3.75 10"
        stroke="#02E562"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Questionmark = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M12 13.5V12.75C12.5192 12.75 13.0267 12.596 13.4584 12.3076C13.8901 12.0192 14.2265 11.6092 14.4252 11.1295C14.6239 10.6499 14.6758 10.1221 14.5746 9.61289C14.4733 9.10369 14.2233 8.63596 13.8562 8.26885C13.489 7.90173 13.0213 7.65173 12.5121 7.55044C12.0029 7.44915 11.4751 7.50114 10.9955 7.69982C10.5158 7.8985 10.1058 8.23495 9.81739 8.66663C9.52895 9.09831 9.375 9.60583 9.375 10.125"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Chain = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3492_1192)">
        <g clipPath="url(#clip1_3492_1192)">
          <path
            d="M9.55469 5.57867L11.1016 4.03179C11.7565 3.43486 12.6162 3.11323 13.5022 3.13374C14.3881 3.15425 15.232 3.51532 15.8586 4.14192C16.4852 4.76853 16.8463 5.61247 16.8668 6.49838C16.8873 7.3843 16.5657 8.24405 15.9687 8.89898L13.7578 11.1021C13.4392 11.4219 13.0605 11.6757 12.6436 11.8489C12.2266 12.022 11.7796 12.1112 11.3281 12.1112C10.8767 12.1112 10.4296 12.022 10.0127 11.8489C9.59573 11.6757 9.21708 11.4219 8.89844 11.1021"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.4452 14.4212L8.89837 15.9681C8.24344 16.565 7.38369 16.8866 6.49777 16.8661C5.61186 16.8456 4.76792 16.4845 4.14131 15.8579C3.51471 15.2313 3.15364 14.3874 3.13313 13.5015C3.11262 12.6156 3.43425 11.7558 4.03118 11.1009L6.24212 8.89775C6.56076 8.57791 6.93941 8.32413 7.35636 8.15097C7.7733 7.97781 8.22033 7.88867 8.67181 7.88867C9.12328 7.88867 9.57031 7.97781 9.98725 8.15097C10.4042 8.32413 10.7829 8.57791 11.1015 8.89775"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3492_1192">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_3492_1192">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TimerIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4460_483)">
        <path
          d="M16.3334 28.668C22.4085 28.668 27.3334 23.7431 27.3334 17.668C27.3334 11.5928 22.4085 6.66797 16.3334 6.66797C10.2582 6.66797 5.33337 11.5928 5.33337 17.668C5.33337 23.7431 10.2582 28.668 16.3334 28.668Z"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M16.3334 17.6648L21.2834 12.7148"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 2.66797H19.3334"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4460_483">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HealthIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4483_600)">
        <path
          d="M12 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V13C4 12.7348 4.10536 12.4804 4.29289 12.2929C4.48043 12.1054 4.73478 12 5 12H12V5C12 4.73478 12.1054 4.48043 12.2929 4.29289C12.4804 4.10536 12.7348 4 13 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V12H27C27.2652 12 27.5196 12.1054 27.7071 12.2929C27.8946 12.4804 28 12.7348 28 13V19C28 19.2652 27.8946 19.5196 27.7071 19.7071C27.5196 19.8946 27.2652 20 27 20H20V27C20 27.2652 19.8946 27.5196 19.7071 27.7071C19.5196 27.8946 19.2652 28 19 28H13C12.7348 28 12.4804 27.8946 12.2929 27.7071C12.1054 27.5196 12 27.2652 12 27V20Z"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4483_600">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RandomDrawIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 0.5H3C2.33759 0.50206 1.7029 0.766114 1.23451 1.23451C0.766114 1.7029 0.50206 2.33759 0.5 3V13C0.50206 13.6624 0.766114 14.2971 1.23451 14.7655C1.7029 15.2339 2.33759 15.4979 3 15.5H13C13.6624 15.4979 14.2971 15.2339 14.7655 14.7655C15.2339 14.2971 15.4979 13.6624 15.5 13V3C15.4979 2.33759 15.2339 1.7029 14.7655 1.23451C14.2971 0.766114 13.6624 0.50206 13 0.5ZM5.1875 6.125C5.00208 6.125 4.82082 6.07002 4.66665 5.967C4.51248 5.86399 4.39232 5.71757 4.32136 5.54627C4.25041 5.37496 4.23184 5.18646 4.26801 5.0046C4.30419 4.82275 4.39348 4.6557 4.52459 4.52459C4.6557 4.39348 4.82275 4.30419 5.0046 4.26801C5.18646 4.23184 5.37496 4.25041 5.54627 4.32136C5.71757 4.39232 5.86399 4.51248 5.967 4.66665C6.07002 4.82082 6.125 5.00208 6.125 5.1875C6.125 5.43614 6.02623 5.6746 5.85041 5.85041C5.6746 6.02623 5.43614 6.125 5.1875 6.125ZM8 8.9375C7.81458 8.9375 7.63332 8.88252 7.47915 8.7795C7.32498 8.67649 7.20482 8.53007 7.13386 8.35877C7.06291 8.18746 7.04434 7.99896 7.08051 7.8171C7.11669 7.63525 7.20598 7.4682 7.33709 7.33709C7.4682 7.20598 7.63525 7.11669 7.8171 7.08051C7.99896 7.04434 8.18746 7.06291 8.35877 7.13386C8.53007 7.20482 8.67649 7.32498 8.7795 7.47915C8.88252 7.63332 8.9375 7.81458 8.9375 8C8.9375 8.24864 8.83873 8.4871 8.66291 8.66291C8.4871 8.83873 8.24864 8.9375 8 8.9375ZM10.8125 11.75C10.6271 11.75 10.4458 11.695 10.2917 11.592C10.1375 11.489 10.0173 11.3426 9.94636 11.1713C9.87541 11 9.85684 10.8115 9.89301 10.6296C9.92919 10.4477 10.0185 10.2807 10.1496 10.1496C10.2807 10.0185 10.4477 9.92919 10.6296 9.89301C10.8115 9.85684 11 9.87541 11.1713 9.94636C11.3426 10.0173 11.489 10.1375 11.592 10.2917C11.695 10.4458 11.75 10.6271 11.75 10.8125C11.75 11.0611 11.6512 11.2996 11.4754 11.4754C11.2996 11.6512 11.0611 11.75 10.8125 11.75Z"
        fill="white"
        fillOpacity="0.6"
      />
    </svg>
  );
};

export const MetamaskFox = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.0892 3.11914L15.3447 9.6138L16.9618 5.78204L24.0892 3.11914Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.90198 3.12109L12.5762 9.67728L11.0382 5.78399L3.90198 3.12109Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9428 18.1758L18.6139 21.7439L23.5969 23.1149L25.0295 18.2549L20.9428 18.1758Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.97925 18.2549L4.40298 23.1149L9.38603 21.7439L7.05709 18.1758L2.97925 18.2549Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.10488 12.1473L7.71631 14.2477L12.6642 14.4674L12.4884 9.15039L9.10488 12.1473Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8863 12.1463L15.4589 9.08789L15.3446 14.4664L20.2837 14.2467L18.8863 12.1463Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.38599 21.7449L12.3565 20.2948L9.79025 18.291L9.38599 21.7449Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6345 20.2948L18.6138 21.7449L18.2007 18.291L15.6345 20.2948Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6139 21.7431L15.6346 20.293L15.8719 22.2352L15.8456 23.0525L18.6139 21.7431Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.38611 21.7431L12.1545 23.0525L12.1369 22.2352L12.3566 20.293L9.38611 21.7431Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1983 17.0058L9.71997 16.2763L11.4689 15.4766L12.1983 17.0058Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7928 17.0058L16.5223 15.4766L18.28 16.2763L15.7928 17.0058Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.38607 21.7419L9.80791 18.1738L7.05713 18.2529L9.38607 21.7419Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.192 18.1738L18.6139 21.7419L20.9428 18.2529L18.192 18.1738Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2837 14.2461L15.3446 14.4658L15.8016 17.0057L16.531 15.4765L18.2887 16.2762L20.2837 14.2461Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.72007 16.2762L11.4778 15.4765L12.1984 17.0057L12.6642 14.4658L7.71631 14.2461L9.72007 16.2762Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.71631 14.2461L9.79038 18.2888L9.72007 16.2762L7.71631 14.2461Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2888 16.2762L18.2009 18.2888L20.2838 14.2461L18.2888 16.2762Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6642 14.4668L12.1984 17.0067L12.7784 20.0035L12.9102 16.0575L12.6642 14.4668Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3447 14.4668L15.1074 16.0487L15.2129 20.0035L15.8017 17.0067L15.3447 14.4668Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8016 17.0048L15.2128 20.0017L15.6346 20.2917L18.2008 18.2879L18.2887 16.2754L15.8016 17.0048Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.71997 16.2754L9.79028 18.2879L12.3565 20.2917L12.7784 20.0017L12.1983 17.0048L9.71997 16.2754Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8455 23.0517L15.8719 22.2343L15.6522 22.041H12.3389L12.1368 22.2343L12.1543 23.0517L9.38599 21.7422L10.3527 22.5331L12.3125 23.8954H15.6785L17.6471 22.5331L18.6139 21.7422L15.8455 23.0517Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6346 20.292L15.2128 20.002H12.7784L12.3566 20.292L12.1368 22.2342L12.339 22.0409H15.6522L15.8719 22.2342L15.6346 20.292Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.4582 10.0376L25.2053 6.45192L24.0891 3.12109L15.6346 9.39605L18.8864 12.1468L23.4827 13.4915L24.5022 12.305L24.0628 11.9886L24.7658 11.3471L24.221 10.9252L24.924 10.3891L24.4582 10.0376Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.7948 6.45192L3.54182 10.0376L3.06724 10.3891L3.77032 10.9252L3.23422 11.3471L3.9373 11.9886L3.49788 12.305L4.50855 13.4915L9.10491 12.1468L12.3566 9.39605L3.90214 3.12109L2.7948 6.45192Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4828 13.4892L18.8864 12.1445L20.2838 14.245L18.2009 18.2877L20.9429 18.2525H25.0296L23.4828 13.4892Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1048 12.1445L4.50844 13.4892L2.97925 18.2525H7.05709L9.7903 18.2877L7.71622 14.245L9.1048 12.1445Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3447 14.4662L15.6347 9.39526L16.9705 5.7832H11.0383L12.3566 9.39526L12.6642 14.4662L12.7697 16.0657L12.7784 20.0029H15.2128L15.2304 16.0657L15.3447 14.4662Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0753296"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WalletConnectIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.455 17.9999C35.455 27.6401 27.6402 35.4549 18 35.4549C8.35991 35.4549 0.545044 27.6401 0.545044 17.9999C0.545044 8.35979 8.35991 0.544922 18 0.544922C27.6402 0.544922 35.455 8.35979 35.455 17.9999Z"
        fill="#3396FF"
        stroke="#66B1FF"
      />
      <path
        d="M11.0267 13.4066C14.8779 9.65094 21.1221 9.65094 24.9733 13.4066L25.4368 13.8585C25.6294 14.0463 25.6294 14.3507 25.4368 14.5385L23.8513 16.0847C23.755 16.1786 23.5989 16.1786 23.5026 16.0847L22.8648 15.4627C20.178 12.8427 15.822 12.8427 13.1353 15.4627L12.4522 16.1288C12.3559 16.2227 12.1998 16.2227 12.1035 16.1288L10.518 14.5826C10.3254 14.3948 10.3254 14.0904 10.518 13.9026L11.0267 13.4066ZM28.2525 16.6042L29.6636 17.9803C29.8562 18.168 29.8562 18.4725 29.6636 18.6602L23.3006 24.8652C23.1081 25.053 22.7959 25.053 22.6033 24.8652L18.0872 20.4614C18.0391 20.4144 17.9611 20.4144 17.9129 20.4614L13.3969 24.8652C13.2044 25.053 12.8922 25.053 12.6996 24.8652L6.33644 18.6601C6.14388 18.4724 6.14388 18.1679 6.33644 17.9802L7.74759 16.6041C7.94016 16.4163 8.25236 16.4163 8.44492 16.6041L12.961 21.008C13.0092 21.0549 13.0872 21.0549 13.1354 21.008L17.6513 16.6041C17.8438 16.4162 18.156 16.4162 18.3486 16.6041L22.8647 21.008C22.9129 21.0549 22.9909 21.0549 23.039 21.008L27.5552 16.6042C27.7477 16.4163 28.0599 16.4163 28.2525 16.6042Z"
        fill="white"
      />
    </svg>
  );
};

export const EthereumIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2990_56)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4057 1.54247L4.42057 15.5235C4.39375 15.5562 4.36942 15.5915 4.348 15.6292C4.32239 15.6742 4.30179 15.7212 4.28622 15.7695C4.24409 15.8994 4.23948 16.0344 4.26748 16.1612C4.28314 16.2325 4.30934 16.302 4.34607 16.3674C4.36742 16.4054 4.39215 16.4418 4.42005 16.4758L15.4057 30.4575C15.4129 30.4669 15.4203 30.4761 15.428 30.4851C15.4568 30.519 15.4886 30.5504 15.5229 30.5787C15.6526 30.6857 15.8188 30.75 16 30.75C16.1919 30.75 16.367 30.6779 16.4996 30.5594C16.5173 30.5436 16.5342 30.527 16.5503 30.5096C16.5657 30.4929 16.5804 30.4755 16.5943 30.4575L27.5799 16.4758C27.6078 16.4418 27.6326 16.4054 27.6539 16.3674C27.7539 16.1891 27.78 15.9722 27.7132 15.7678C27.6977 15.7202 27.6774 15.6739 27.6521 15.6295C27.6307 15.5916 27.6063 15.5562 27.5794 15.5235L16.5943 1.54247C16.5804 1.52444 16.5657 1.50706 16.5503 1.49038C16.4133 1.34254 16.2174 1.25 16 1.25C15.8081 1.25 15.633 1.32207 15.5004 1.44063C15.4828 1.45634 15.4659 1.47294 15.4497 1.49038C15.4343 1.50706 15.4196 1.52444 15.4057 1.54247ZM25.8202 15.7124L16.75 4.16849V19.8352L25.8202 15.7124ZM24.5094 17.9559L16.75 21.4829V27.8315L24.5094 17.9559ZM15.25 27.8315V21.4829L7.49063 17.9559L15.25 27.8315ZM6.17977 15.7124L15.25 19.8352V4.16849L6.17977 15.7124Z"
          fill="#9075D1"
        />
      </g>
      <defs>
        <clipPath id="clip0_2990_56">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5210_3828)">
      <g clipPath="url(#clip1_5210_3828)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.25 9.0625C3.25 5.85234 5.85234 3.25 9.0625 3.25C12.2727 3.25 14.875 5.85234 14.875 9.0625C14.875 12.2727 12.2727 14.875 9.0625 14.875C5.85234 14.875 3.25 12.2727 3.25 9.0625ZM9.0625 1.75C5.02392 1.75 1.75 5.02392 1.75 9.0625C1.75 13.1011 5.02392 16.375 9.0625 16.375C10.8116 16.375 12.4172 15.7609 13.6756 14.7366L16.9693 18.0303C17.2622 18.3232 17.7371 18.3232 18.03 18.0303C18.3229 17.7374 18.3229 17.2625 18.03 16.9697L14.7363 13.676C15.7608 12.4175 16.375 10.8117 16.375 9.0625C16.375 5.02392 13.1011 1.75 9.0625 1.75Z"
          fill="white"
          fillOpacity="0.4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5210_3828">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_5210_3828">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FiltersIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5833_2995)">
      <g clipPath="url(#clip1_5833_2995)">
        <path
          d="M11.125 13.4375H3.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.375 13.4375H13.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.125 6.5625H3.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.375 6.5625H8.625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.625 4.6875V8.4375"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.625 15.3125V11.5625"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5833_2995">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
      <clipPath id="clip1_5833_2995">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
export const PlayIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 0.875C7.39303 0.875 5.82214 1.35152 4.486 2.24431C3.14985 3.1371 2.10844 4.40605 1.49348 5.8907C0.87852 7.37535 0.717618 9.00901 1.03112 10.5851C1.34463 12.1612 2.11846 13.6089 3.25476 14.7452C4.39106 15.8815 5.8388 16.6554 7.4149 16.9689C8.99099 17.2824 10.6247 17.1215 12.1093 16.5065C13.594 15.8916 14.8629 14.8502 15.7557 13.514C16.6485 12.1779 17.125 10.607 17.125 9C17.1209 6.84638 16.2635 4.78216 14.7407 3.25932C13.2178 1.73648 11.1536 0.87913 9 0.875ZM11.8438 9.52344L8.09375 12.0234C7.99032 12.0874 7.87161 12.1225 7.75 12.125C7.64693 12.1249 7.54529 12.1008 7.45313 12.0547C7.35321 12.0008 7.26987 11.9206 7.21206 11.8229C7.15425 11.7252 7.12415 11.6135 7.125 11.5V6.5C7.12415 6.38646 7.15425 6.27483 7.21206 6.1771C7.26987 6.07938 7.35321 5.99924 7.45313 5.94531C7.55345 5.89453 7.66526 5.87071 7.77758 5.87618C7.88989 5.88166 7.99885 5.91625 8.09375 5.97656L11.8438 8.47656C11.9308 8.53336 12.0023 8.61097 12.0518 8.70237C12.1013 8.79376 12.1272 8.89606 12.1272 9C12.1272 9.10394 12.1013 9.20624 12.0518 9.29763C12.0023 9.38903 11.9308 9.46664 11.8438 9.52344Z"
        fill="white"
      />
    </svg>
  );
};

export const WarningIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5866_6595)">
        <g clipPath="url(#clip1_5866_6595)">
          <path
            d="M12 9.75V13.5"
            stroke="var(--orange-6)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.7058 3.75024L2.45585 18.0002C2.32442 18.2279 2.25512 18.4861 2.25488 18.7489C2.25465 19.0118 2.3235 19.2701 2.45452 19.498C2.58555 19.7258 2.77416 19.9153 3.00145 20.0473C3.22875 20.1793 3.48674 20.2493 3.7496 20.2502H20.2496C20.5125 20.2493 20.7705 20.1793 20.9977 20.0473C21.225 19.9153 21.4136 19.7258 21.5447 19.498C21.6757 19.2701 21.7445 19.0118 21.7443 18.7489C21.7441 18.4861 21.6748 18.2279 21.5434 18.0002L13.2934 3.75024C13.1629 3.5223 12.9746 3.33287 12.7474 3.20113C12.5202 3.06938 12.2622 3 11.9996 3C11.737 3 11.479 3.06938 11.2518 3.20113C11.0246 3.33287 10.8363 3.5223 10.7058 3.75024V3.75024Z"
            stroke="var(--orange-6)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
            fill="#FF3C23"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5866_6595">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_5866_6595">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InfoIcon: React.FC<IconProps> = ({ stroke = 'white' }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5668_9265)">
        <g clipPath="url(#clip1_5668_9265)">
          <path
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 11.25H12V16.5H12.75"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.8906 7.875C12.8906 8.47043 12.4079 8.95312 11.8125 8.95312C11.2171 8.95312 10.7344 8.47043 10.7344 7.875C10.7344 7.27957 11.2171 6.79688 11.8125 6.79688C12.4079 6.79688 12.8906 7.27957 12.8906 7.875Z"
            fill={stroke}
            stroke={stroke}
            strokeWidth="0.09375"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5668_9265">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_5668_9265">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DuskbreakersIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5754_6487)">
        <path
          d="M19.9052 0.863281C9.28164 0.863281 0.670898 9.47402 0.670898 20.0976C0.670898 30.7211 9.28164 39.3319 19.9052 39.3319C30.5287 39.3319 39.1395 30.7211 39.1395 20.0976C39.1395 9.47402 30.5287 0.863281 19.9052 0.863281ZM26.3477 5.13757C29.7943 6.62774 32.627 9.27391 34.3562 12.5865C24.2533 12.0639 21.2516 10.6223 20.15 5.13757C20.0664 4.71791 19.9926 4.27494 19.9285 3.80865C22.2075 3.8106 24.3776 4.28465 26.3477 5.13757ZM13.4627 5.13757C15.4327 4.28465 17.6048 3.8106 19.8838 3.80865C19.8197 4.27688 19.7459 4.71985 19.6623 5.13757C18.5588 10.6223 15.559 12.0619 5.45616 12.5865C7.18141 9.27391 10.016 6.62774 13.4627 5.13757ZM19.9052 21.5936C14.2204 21.5936 9.15924 24.2553 5.8933 28.3975C4.44781 25.965 3.61627 23.1265 3.61627 20.0976C3.61627 17.4145 4.26907 14.881 5.42313 12.6467C16.4352 13.214 19.0154 14.8693 19.9052 21.5936C19.9052 21.5936 19.9052 21.578 19.9052 21.5489C19.9052 21.578 19.9052 21.5936 19.9052 21.5936C20.795 14.8693 23.3751 13.214 34.3892 12.6467C35.5432 14.881 36.196 17.4145 36.196 20.0976C36.196 23.1265 35.3645 25.965 33.9171 28.3975C30.6511 24.2553 25.59 21.5936 19.9052 21.5936Z"
          fill="#332949"
        />
      </g>
      <defs>
        <clipPath id="clip0_5754_6487">
          <rect
            width="38.8571"
            height="38.8571"
            fill="white"
            transform="translate(0.476562 0.666992)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EllipseCut = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="204"
      height="212"
      viewBox="0 0 204 212"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.654 59.8932L202.73 60.2762C196.096 44.2778 185.76 30.2005 172.791 19.1132L173.441 18.3531C186.528 29.5413 196.958 43.7471 203.654 59.8932ZM59.8941 0.34668L60.2772 1.27041C44.2788 7.90467 30.2015 18.2402 19.1142 31.2095L18.3541 30.5597C29.5422 17.4724 43.7481 7.04216 59.8941 0.34668ZM0.347656 144.106L1.27139 143.723C7.90565 159.722 18.2411 173.799 31.2105 184.886L30.5607 185.647C17.4734 174.458 7.04314 160.252 0.347656 144.106ZM93.3618 211.666L93.4392 210.669C96.2641 210.888 99.1193 211 102.001 211C104.882 211 107.738 210.888 110.562 210.669L110.64 211.666C107.789 211.887 104.908 212 102.001 212C99.0934 212 96.2123 211.887 93.3618 211.666ZM144.107 203.653L143.724 202.729C159.723 196.095 173.8 185.759 184.887 172.79L185.647 173.44C174.459 186.527 160.253 196.957 144.107 203.653Z"
        fill="url(#paint0_linear_6421_8684)"
        fillOpacity="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6421_8684"
          x1="102.001"
          y1="-8"
          x2="102.001"
          y2="212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8972BD" />
          <stop offset="1" stopColor="#8871BC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Ellipse = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="280"
      height="280"
      viewBox="0 0 280 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="140"
        cy="140"
        r="138.5"
        stroke="url(#paint0_linear_6421_8695)"
        strokeOpacity="0.5"
        strokeWidth="3"
        strokeDasharray="1 42"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6421_8695"
          x1="140"
          y1="0"
          x2="140"
          y2="280"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8972BD" />
          <stop offset="1" stopColor="#8871BC" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SquaresShape = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6421_8697)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.939453 0.960938H1.68945H5.86258H6.61258V1.71094V5.16309H9.38883V1.71094V0.960938H10.1388H14.312H15.062V1.71094V5.88406V6.63406H14.312H10.8151V9.36529H14.312H15.062V10.1153V14.2884V15.0384H14.312H10.1388H9.38883V14.2884V10.8362H6.61258V14.2884V15.0384H5.86258H1.68945H0.939453V14.2884V10.1153V9.36529H1.68945H5.14197V6.63406H1.68945H0.939453V5.88406V1.71094V0.960938ZM2.43945 2.46094V5.13406H5.11258V2.46094H2.43945ZM2.43945 10.8653V13.5384H5.11258V10.8653H2.43945ZM10.8888 5.13406V2.46094H13.562V5.13406H10.8888ZM10.8888 10.8653V13.5384H13.562V10.8653H10.8888ZM6.64197 9.33621V6.66309H9.31509V9.33621H6.64197Z"
          fill="#483C66"
        />
      </g>
      <defs>
        <clipPath id="clip0_6421_8697">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShapeHorizontal = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46289 1.16699C2.50039 4.19262 4.96477 6.63449 8.00039 6.63449C11.036 6.63449 13.4998 4.19324 13.5373 1.16699"
        stroke="#312847"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M13.5373 15.657C13.4998 12.6313 11.0354 10.1895 7.99977 10.1895C4.96477 10.1895 2.50039 12.6307 2.46289 15.657"
        stroke="#312847"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M2.46289 8.41211H13.5366" stroke="#312847" strokeWidth="1.5" strokeMiterlimit="10" />
    </svg>
  );
};

export const ShapeVertical = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.255 1.66504C10.7931 1.70816 8 4.52754 8 8.00004C8 11.4719 10.7931 14.2913 14.255 14.3344"
        stroke="#312847"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M1.74414 14.3354C5.20602 14.2923 7.99914 11.4729 7.99914 8.00039C7.99914 4.52852 5.20602 1.70914 1.74414 1.66602"
        stroke="#312847"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M8 13.4062V2.59375" stroke="#312847" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M3.46875 7.92383H12.5312" stroke="#312847" strokeWidth="1.5" strokeMiterlimit="10" />
    </svg>
  );
};

export const CursorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5754_6146)">
      <path
        d="M15.7504 10.5V9.375C15.7504 8.87772 15.5529 8.40081 15.2013 8.04917C14.8496 7.69754 14.3727 7.5 13.8754 7.5C13.3782 7.5 12.9013 7.69754 12.5496 8.04917C12.198 8.40081 12.0004 8.87772 12.0004 9.375V3.375C12.0004 2.87772 11.8029 2.40081 11.4513 2.04917C11.0996 1.69754 10.6227 1.5 10.1254 1.5C9.62817 1.5 9.15125 1.69754 8.79962 2.04917C8.44799 2.40081 8.25045 2.87772 8.25045 3.375V14.7469L6.19732 11.1844C5.94868 10.753 5.53885 10.438 5.058 10.3088C4.57714 10.1796 4.06465 10.2467 3.63326 10.4953C3.20187 10.744 2.88692 11.1538 2.75769 11.6346C2.62847 12.1155 2.69556 12.628 2.9442 13.0594C6.00045 19.5 7.8567 21.75 12.0004 21.75C12.9854 21.75 13.9606 21.556 14.8706 21.1791C15.7805 20.8022 16.6073 20.2497 17.3037 19.5533C18.0002 18.8569 18.5526 18.0301 18.9295 17.1201C19.3065 16.2102 19.5004 15.2349 19.5004 14.25V10.5C19.5004 10.0027 19.3029 9.52581 18.9513 9.17417C18.5996 8.82254 18.1227 8.625 17.6254 8.625C17.1282 8.625 16.6513 8.82254 16.2996 9.17417C15.948 9.52581 15.7504 10.0027 15.7504 10.5V10.5Z"
        stroke="#9075D1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5754_6146">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LooksRareIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6372_10079)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99975 11.3511C8.56988 11.3511 7.40967 10.192 7.40967 8.761C7.40967 7.32994 8.56988 6.1709 9.99975 6.1709C11.4296 6.1709 12.5898 7.32994 12.5898 8.761C12.5898 10.192 11.4296 11.3511 9.99975 11.3511ZM8.87363 8.761C8.87363 9.38319 9.37807 9.88711 9.99975 9.88711C10.6214 9.88711 11.1259 9.38319 11.1259 8.761C11.1259 8.1388 10.6214 7.63487 9.99975 7.63487C9.37807 7.63487 8.87363 8.1388 8.87363 8.761Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6665 8.76454L6.62145 3.80615H13.3782L18.3332 8.76454L9.99984 17.0945L1.6665 8.76454ZM13.8287 6.95928C11.7233 4.84471 8.27633 4.84473 6.171 6.9593L4.36921 8.76112L6.171 10.5629C8.27633 12.6775 11.7233 12.6775 13.8287 10.5629L15.6305 8.76112L13.8287 6.95928Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6372_10079">
          <rect
            width="16.6667"
            height="16.6667"
            fill="white"
            transform="translate(1.6665 1.6665)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CoinbaseNftIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 10C17.5 5.85792 14.1421 2.5 10 2.5C5.85792 2.5 2.5 5.85792 2.5 10C2.5 14.1421 5.85792 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10ZM7.36742 9.99997C7.36742 11.4544 8.5453 12.6355 10.003 12.6355C11.3078 12.6355 12.388 11.6854 12.5963 10.4392H15.2546C15.0301 13.1464 12.7655 15.2744 9.99974 15.2744C7.0876 15.2744 4.72534 12.9121 4.72534 9.99997C4.72534 7.08783 7.0876 4.72557 9.99974 4.72557C12.7655 4.72557 15.0301 6.85355 15.2546 9.56071H12.5995C12.3913 8.31451 11.3078 7.3644 10.003 7.3644C8.54855 7.3644 7.36742 8.54553 7.36742 9.99997Z"
        fill="white"
      />
    </svg>
  );
};

export const GradientIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6662_6812)">
        <path
          d="M4 13H14"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 13H28"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 18H9.5"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 18H28"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 18H19"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 23H7"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 23H14"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 23H21"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 23H28"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 8H28"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6662_6812">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OffsetIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6662_6825)">
        <path
          d="M20 11H6C5.44772 11 5 11.4477 5 12V26C5 26.5523 5.44772 27 6 27H20C20.5523 27 21 26.5523 21 26V12C21 11.4477 20.5523 11 20 11Z"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 5H18"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 5H26C26.2652 5 26.5196 5.10536 26.7071 5.29289C26.8946 5.48043 27 5.73478 27 6V7"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 14V12"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25 21H26C26.2652 21 26.5196 20.8946 26.7071 20.7071C26.8946 20.5196 27 20.2652 27 20V19"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 5H12C11.7348 5 11.4804 5.10536 11.2929 5.29289C11.1054 5.48043 11 5.73478 11 6V7"
          stroke="#9075D1"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6662_6825">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
